import { ModalLayout } from 'root/src/client/v2/common/layouts/ModalLayout';
import { PlatformIcon, PlatformIconColor } from 'root/src/client/web/base/CustomButton/PlatformIcon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import { faGift } from '@fortawesome/pro-regular-svg-icons/faGift';
import { ButtonNew } from 'root/src/client/v2/common/components/form/ButtonNew';
import { getReadablePlatform } from 'root/src/shared/platforms/helpers/getReadablePlatform';
export const OnlySubscribersModal = ({ profileURL, platform }) => {
    return (<ModalLayout>
			<div className="flex flex-col gap-4 px-4 w-[400px] h-full">
				<div className="flex flex-col items-center justify-center gap-4">
					<div className="relative">
						<div className="flex w-24 min-h-24 items-center  justify-center rounded-2xl bg-white">
							<PlatformIcon color={PlatformIconColor.Colorized} platform={platform} size="3x"/>
						</div>
						<div className="absolute -bottom-2 -right-2 flex h-10 w-10 items-center justify-center rounded-full bg-red-500 border-4 border-dark-3 shadow-lg">
							<FontAwesomeIcon icon={faLock}/>
						</div>
					</div>
					<h1 className="mx-2 font-mono capitalize font-bold text-center text-2xl">
						Subscribers Only
					</h1>
					<p className="text-light-4 text-center">
						This giveaway is locked! Join the sub crew today to unlock this giveaway and support the creator.
					</p>
					<a href={profileURL} target="_blank" className="w-full flex" rel="noreferrer">
						<ButtonNew type="button" className="w-full py-3">
							<FontAwesomeIcon className="mr-1" icon={faGift}/> Subscribe on {getReadablePlatform(platform)}
						</ButtonNew>
					</a>
				</div>
			</div>
		</ModalLayout>);
};
